import React from 'react';
import {
  QuestionContainer,
  TitleField,
  OptionsField,
  OptionChip,
  Text,
} from './styles';

interface Props {
  checkBoxQuestion: any;
}

const CheckBoxStyleQuestionSummary: React.FC<Props> = ({
  checkBoxQuestion,
}) => {
  const getQuestionText = (): string => {
    const { questionIdComplete, question } = checkBoxQuestion;

    if (!questionIdComplete.includes('.')) {
      return question.text;
    }

    const alternativeId = Number(questionIdComplete.split('.')[1]);
    const alternative = question.alternatives.find(
      (item: any) => item.value === alternativeId,
    );

    return alternative?.text;
  };

  const selectedOptions: string[] = Array.isArray(
    checkBoxQuestion.result.optionText,
  )
    ? checkBoxQuestion.result.optionText
        .map((option: { text?: string }) => option?.text)
        .filter(Boolean)
    : [];

  return (
    <QuestionContainer>
      <TitleField>
        <Text>
          {checkBoxQuestion.customQuestionText !== ''
            ? checkBoxQuestion.customQuestionText
            : getQuestionText()}
        </Text>
      </TitleField>
      <OptionsField>
        {selectedOptions.length > 0 ? (
          selectedOptions.map(option => (
            <OptionChip key={option}>
              <Text>{option}</Text>
            </OptionChip>
          ))
        ) : (
          <Text>Keine Antwort</Text>
        )}
      </OptionsField>
    </QuestionContainer>
  );
};

export default CheckBoxStyleQuestionSummary;
